import UserManagementComponent from "components-base/pages/usermanagement/usermanagement";
export const UserManagement = () =>{
    return(
        <div className="flex w-full flex-col gap-5"><UserManagementComponent /></div>
    )
}
export default UserManagement;